import { render, staticRenderFns } from "./SettingsIcon.vue?vue&type=template&id=1b65f47e"
var script = {}


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1b65f47e')) {
      api.createRecord('1b65f47e', component.options)
    } else {
      api.reload('1b65f47e', component.options)
    }
    module.hot.accept("./SettingsIcon.vue?vue&type=template&id=1b65f47e", function () {
      api.rerender('1b65f47e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/icons/SettingsIcon.vue"
export default component.exports